import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
import languageLogo from "../../assets/images/languageLogo.svg";
import globalIcon from "../../assets/images/globalIcon.svg";
import homeLogo from "../../assets/images/homeLogo.svg";
import uplLogoDark from "../../assets/images/uplLogoDark.svg"
import Dropdown from "../Dropdown/Dropdown";
import FeedbackPopup from "../Feedback/Feedback";
import logoutIcon from "../../assets/images/logoutIcon.svg"
import languageLogoDark from "../../assets/images/languageLogoDark.svg"
import logoutDark from "../../assets/images/logoutDark.svg"
import logoutIconPopup from "../../assets/images/logoutIconPopup.svg"
import 'react-toastify/dist/ReactToastify.css';
import { useTranslationContext } from "../../contexts/TranslationContext";
import { toast } from "react-toastify";
import uplLogoMain from "../../assets/images/uplLogoMain.png"
import { encrypted } from "../../utils/Utility";
import carbonBook from "../../assets/images/carbonBook.svg";
import carbonHome from "../../assets/images/carbonHome.svg"
import chatIcon from "../../assets/images/chatIcon.svg";
import feedbackIconOrange from "../../assets/images/feedbackIconOrange.svg"
import carbonBookOrange from "../../assets/images/carbonBookOrange.svg"
import carbonChatOrange from "../../assets/images/carbonChatOrange.svg"
import carbonHomeOrange from "../../assets/images/carbon_homeOrange.svg";
import feedbackIcon from "../../assets/images/feedbackIcon.svg";
import dropDownDark from "../../assets/images/dropdownDark.svg"
import { clearLocalStoragePreservingTheme } from "../../utils/Utility";
import aboutIcon from "../../assets/images/aboutIcon.svg";
import policyIcon from "../../assets/images/policyIcon.svg";
import aboutIconDark from "../../assets/images/aboutIconDark.svg";
import policyIconDark from "../../assets/images/policyIconDark.svg";
import Policy from "../Policy/Policy";
import policyPDF from "../../assets/logos/UPL AI Acceptable Usage Policy.pdf";
import aboutPDF from "../../assets/logos/ChatNPP - Model Guide 1.pdf";
// import settingsIcon from "../../assets/images/settingsIcon.png"
import { fetchModel } from "../../store/apiActions";
import { useSelector } from "react-redux";
import { env } from "../../environment";
import dropDownLogo from "../../assets/images/dropDownLogo.svg"
import { useDispatch } from "react-redux";
import { ThemeContext } from "../../contexts/ThemeContext";
import darkMode from "../../assets/images/darkMode1.svg"
import lightMode from "../../assets/images/lightMode.svg"
import carbonFeedbackDark from "../../assets/images/carbonFeedbackDark.svg"
import carbonBookDark from "../../assets/images/carbonBookDark.svg"
import carbonChatDark from "../../assets/images/carbonChatDark.svg"
import carbonHomeDark from "../../assets/images/carbonHomeDark.svg";
import globalIconDark from "../../assets/images/globalIconDark.svg"
import { postSavePolicy } from "../../store/apiActions";
import hamburgerDark from "../../assets/images/hamburgerDark.svg";
import hamburger from "../../assets/images/hamburger.svg"
import faqDark from "../../assets/images/faqDark.svg";
import faqLight from "../../assets/images/faqLight.svg";

const Navbar = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
  const [userName, setUserName] = useState("");
  const feedbackContainerRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const { translations, countries, languages, selectedPlaceholderLanguage, placeholderLanguage, setManualCountrySelected, setManualLanguageSelected, manualCountrySelected, manualLanguageSelected, selectedLanguage, setSelectedLanguage, selectedCountry, setSelectedCountry } = useTranslationContext();
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [selectedModel, setSelectedModel] = useState("GPT-4o");
  const { isDarkMode, toggleDarkMode } = useContext(ThemeContext);
  const showModels = useSelector((state) => state?.api?.getModel?.data || []);
  const [openPDF, setOpenPDF] = useState(false);
  const [modelTitle, setModelTitle] = useState("AI Usage Policy");
  const [isPolicyFirst, setIsPolicyFirst] = useState(false);
  const homeTranslation = translations["home"] || "Home";
  const academyTranslation = translations["academy"] || "NPP Academy";
  const chatTranslation = translations["chat"] || "Chat";
  const feedbackTranslation = translations["feedback"] || "Feedback";
  // const settingsText = translations["settings"] || "Settings";
  const logoutText = translations["logout"] || "Log out";
  const userGuideText = translations["user_guide"] || "User Guide";

  const accounts = translations["accounts_text"] || "Accounts";
  const model = translations["model_text"] || "Model";
  const language = translations["language_text"] || "Language";
  const country = translations["country_text"] || "Country";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

 useEffect(() => {
  if (!manualLanguageSelected && languages?.length > 0) {
    if (selectedLanguage !== languages[0]) {
      setSelectedLanguage(languages[0]);
      encrypted.setEncryptedItem("language", languages[0]);
    }
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manualLanguageSelected, languages, selectedLanguage]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isSidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);
  
  useEffect(() => {
    try {
      const decrypted = encrypted.decrypt(localStorage.getItem("LoggedInDetails"));
      const parsedDetails = JSON.parse(decrypted);
      if (parsedDetails.full_name) {
        setUserName(parsedDetails.full_name.split(" ")[0]);
      }
    } catch (error) {
      console.error("Failed to parse user details from localStorage:", error);
    }
  }, []);
  useEffect(() => {
    if (!manualCountrySelected && countries?.length > 0) {
      if (selectedCountry !== countries[0]) {
        setSelectedCountry(countries[0]);
        encrypted.setEncryptedItem("country", countries[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manualCountrySelected, countries, selectedCountry]);

  useEffect(() => {
    const data = localStorage.getItem("isPolicy");
    if (data === "true") {
      setOpenPDF(true);
      setIsPolicyFirst(true);
    } else {
      setOpenPDF(false);
      setIsPolicyFirst(false);
    }
  }, []);

  const handlePostPolicySign = async () => {
    try {
      const data = localStorage.getItem("isPolicy");

      if (data === "true") {
        setIsPolicyFirst(true);
        localStorage.setItem("isPolicy", "false");

        const body = {
          policy_name: "AI Usage Policy",
          policy_date_str: "2025_01_16",
        };

        await dispatch(
          postSavePolicy(`${env.baseURL}/save-policy-acceptance`, body)
        );
      }
    } catch (error) {
      console.error("Error saving policy acceptance:", error);
    } finally {
      setOpenPDF(false);
    }
  };
  
  const handleOpenModalPolicy = (data) => {
    setOpenPDF(true);
    setIsSidebarOpen(false);
    setIsUserMenuOpen(true);
    setIsPolicyFirst(false);
    if (data === "AI Usage Policy") {
      setModelTitle("AI Usage Policy");
    } else {
      setModelTitle("Model Selection Guide");
    }
  };

  useEffect(() => {
    encrypted.setEncryptedItem(
      "selectedModel", selectedModel);
  }, [selectedModel]);

  useEffect(() => {
    dispatch(fetchModel(`${env.baseURL}/get-model`));
  }, [dispatch]);


  const toggleFeedbackPopup = () => {
    setIsFeedbackOpen((prev) => !prev);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${env.baseURL}/app-users/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.ok) {
        clearLocalStoragePreservingTheme();
        setTimeout(() => {
        (toast.success("Logout successful!")); 
        }, 100); 
        navigate("/sign-in");
        
      } else {
        clearLocalStoragePreservingTheme();
        navigate("/sign-in");
      }
    } catch (error) {
      clearLocalStoragePreservingTheme();
      navigate("/sign-in");
    }
  };

  const handleOpenModal = () => {
    setIsSidebarOpen(false);
    setShowModal(true);
    setIsUserMenuOpen(true)
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const toggleDropdown = (type) => {
    setOpenDropdown((prev) => (prev === type ? null : type));
  };
    const handleFaqNavigation = () => {
    navigate("/user-guide");
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        feedbackContainerRef.current &&
        !feedbackContainerRef.current.contains(event.target)
      ) {
        setIsFeedbackOpen(false);
      }
      if (
        !event.target.closest('.user-dropdown') &&
        !event.target.closest('.icon-button')
      ) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {!isMobile && (
        <div className={`navbar-container ${isDarkMode ? "dark-mode" : "light-mode"}`}>
          <div className="left-section">
            <div className="branding">
              <img src={isDarkMode ? uplLogoDark : uplLogoMain} alt="UPL Logo" className="home-upl-logo" />
              <span className={`divider ${isDarkMode ? "dark-mode" : "light-mode"}`}>|</span>
              <img src={homeLogo} alt="UPL" className="home-logo" />
            </div>
            <div className={`model-dropdown ${isDarkMode ? "dark-mode" : "light-mode"}`}>
              <div className="dropdown-icon-container">
                <Dropdown
                  label={model}
                  items={showModels}
                  selectedItem={selectedModel}
                  setSelectedItem={(model) => {
                    setSelectedModel(model);
                  }}
                  dropdownState={openDropdown === "model"}
                  setDropdownState={() => toggleDropdown("model")}
                  showArrow={true}
                  arrowIcon={isDarkMode ? dropDownDark : dropDownLogo}
                  shouldShowButtonBackground="true"
                  mode={isDarkMode}
                />
              </div>
            </div>
          </div>
          <div className="dashboard-container">
            <button
              className={`dashboard-button ${location.pathname === "/home"
                ? "active"
                : isDarkMode
                  ? "dark-mode"
                  : "light-mode"
                }`}
              onClick={() => handleNavigation("/home")}
            >
              <span className="icon-label">
                <img
                  src={
                    location.pathname === "/home"
                      ? carbonHomeOrange
                      : isDarkMode
                        ? carbonHomeDark
                        : carbonHome
                  }
                  alt="Home"
                  className="dashboard-icon"
                />
                {homeTranslation}
              </span>
            </button>

            <button
              className={`dashboard-button ${location.pathname === "/chat"
                ? "active"
                : isDarkMode
                  ? "dark-mode"
                  : "light-mode"
                }`}
              onClick={() => handleNavigation("/chat")}
            >
              <span className="icon-label">
                <img
                  src={
                    location.pathname === "/chat"
                      ? carbonChatOrange
                      : isDarkMode
                        ? carbonChatDark
                        : chatIcon
                  }
                  alt="Chat"
                  className="dashboard-icon"
                />
                {chatTranslation}
              </span>
            </button>

            <button
              className={`dashboard-button ${location.pathname === "/npp-academy"
                ? "active"
                : isDarkMode
                  ? "dark-mode"
                  : "light-mode"
                }`}
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  "https://upllimited.sharepoint.com/sites/NPPEAcademy",
                  "_blank"
                );
              }}
            >
              <span className="icon-label">
                <img
                  src={
                    location.pathname === "/npp-academy"
                      ? carbonBookOrange
                      : isDarkMode
                        ? carbonBookDark
                        : carbonBook
                  }
                  alt="Academy"
                  className="dashboard-icon"
                />
                {academyTranslation}
              </span>
            </button>

            <div ref={feedbackContainerRef}>
              <button
                className={`dashboard-button ${location.pathname === "/feedback"
                  ? "active"
                  : isDarkMode
                    ? "dark-mode"
                    : "light-mode"
                  }`}
                onClick={toggleFeedbackPopup}
              >
                <span className="icon-label">
                  <img
                    src={
                      location.pathname === "/feedback"
                        ? feedbackIconOrange
                        : isDarkMode
                          ? carbonFeedbackDark
                          : feedbackIcon
                    }
                    alt="Feedback"
                    className="dashboard-icon"
                  />
                  {feedbackTranslation}
                </span>
              </button>
              {isFeedbackOpen && <FeedbackPopup onClose={toggleFeedbackPopup} />}
            </div>
          </div>

          <div className="right-section">
            <button onClick={toggleDarkMode} className="theme-container">
              <img src={isDarkMode ? darkMode : lightMode} alt="theme" />
            </button>
            <div className="language-container">
              <Dropdown
                label={language}
                items={languages}
                selectedItem={manualLanguageSelected ? selectedPlaceholderLanguage : placeholderLanguage}
                setSelectedItem={(lang) => {
                setSelectedLanguage(lang);
                setManualLanguageSelected(true);
                setManualCountrySelected(false);
                localStorage.setItem("manualLanguageSelected", "true");
                }}
                dropdownState={openDropdown === "language"}
                setDropdownState={() => toggleDropdown("language")}
                icon={isDarkMode ? languageLogoDark : languageLogo}
              />
              <Dropdown
                label={country}
                items={countries}
                selectedItem={manualCountrySelected ?selectedCountry : countries[0]}
                setSelectedItem={(country) => {
                setSelectedCountry(country);
                setManualCountrySelected(true);
                encrypted.setEncryptedItem("country", country); 
                }}
                dropdownState={openDropdown === "country"}
                setDropdownState={() => toggleDropdown("country")}
                icon={isDarkMode ? globalIconDark : globalIcon}
              />
            </div>
            <div className="profile-container" onClick={() => setIsUserMenuOpen(prev => !prev)}>
              <button className="user-icon" >
                {userName ? userName.charAt(0).toUpperCase() : "U"}
              </button>
              <div className="profile-section">
                <span className={`user-name ${isDarkMode ? "dark-mode" : "light-mode"}`}>{userName || "User"}</span>
              </div>
              {isUserMenuOpen && (
                <div className={`user-dropdown ${isDarkMode ? "dark-mode" : "light-mode"}`}>
                  <div className={`dropdown-section-title ${isDarkMode ? "dark-mode" : "light-mode"}`}>{accounts}</div>
                  {/* <div className="dropdown-item-settings">
                <span className="dropdown-icon">
                  <img src={settingsIcon} alt="settings-icon" />
                </span>
                {settingsText}
              </div> */}
                  <div
                    className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`}
                    onClick={() => handleOpenModalPolicy("About")}
                  >
                    <span className="dropdown-icon">
                      <img src={isDarkMode ? aboutIconDark : aboutIcon} alt="" />
                    </span>
                    {"Model Selection Guide"}
                  </div>
                  <div
                    className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`}
                    onClick={() => handleOpenModalPolicy("AI Usage Policy")}
                  >
                    <span className="dropdown-icon">
                      <img src={isDarkMode ? policyIconDark : policyIcon} alt="" />
                    </span>
                    {"AI Usage Policy"}
                  </div>
                  <div className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`} onClick={handleFaqNavigation}>
                    <span className="dropdown-icon">
                      <img src={isDarkMode ? faqDark : faqLight} alt="settings-icon" />
                    </span>
                    {userGuideText}
                  </div>
                  <div className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`} onClick={handleOpenModal}>
                    <span className="dropdown-icon">
                      <img src={isDarkMode ? logoutDark : logoutIcon} alt="settings-icon" />
                    </span>
                    {logoutText}
                  </div>
              
                </div>
              )}
            </div>    
          </div>
        </div>
      )}
      <LogoutModal
        show={showModal}
        handleLogout={handleLogout}
        handleClose={handleCloseModal}
        translations={translations}
      />
      <Policy
        open={openPDF}
        onClose={() => setOpenPDF(true)}
        handleOnclickSubmit={() => handlePostPolicySign()}
        pdfFile={modelTitle === "AI Usage Policy" ? policyPDF : aboutPDF}
        isPolicyFirst={isPolicyFirst}
        heading={modelTitle}
        buttonTitle="Accept & Continue"
      />
      {isMobile && (
        <div className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''} ${isDarkMode ? 'dark' : ''}`} ref={sidebarRef}>

          <div className={`sidebar-header ${isDarkMode ? "dark-mode" : "light-mode"}`}>
            <div className="profile-container">
              <button className="user-icon" >
                {userName ? userName.charAt(0).toUpperCase() : "U"}
              </button>
              <div className="profile-section">
                <span className={`user-name ${isDarkMode ? "dark-mode" : "light-mode"}`}>{userName || "User"}</span>
              </div>
            </div>
          </div>
          <div className={`sidebar-links ${isDarkMode ? "dark-mode" : "light-mode"}`}>
            <div className={`model-dropdown ${isDarkMode ? "dark-mode" : "light-mode"}`}>
              <div className="dropdown-icon-container">
                <Dropdown
                  label={model}
                  items={showModels}
                  selectedItem={selectedModel}
                  setSelectedItem={(model) => {
                    setSelectedModel(model);
                  }}
                  dropdownState={openDropdown === "model"}
                  setDropdownState={() => toggleDropdown("model")}
                  showArrow={true}
                  arrowIcon={isDarkMode ? dropDownDark : dropDownLogo}
                  shouldShowButtonBackground="true"
                  mode={isDarkMode}
                />
              </div>
            </div>
            <div className="dashboard-container">
              <button
                className={`dashboard-button ${location.pathname === "/home"
                  ? "active"
                  : isDarkMode
                    ? "dark-mode"
                    : "light-mode"
                  }`}
                onClick={() => handleNavigation("/home")}
              >
                <span className="icon-label">
                  <img
                    src={
                      location.pathname === "/home"
                        ? carbonHomeOrange
                        : isDarkMode
                          ? carbonHomeDark
                          : carbonHome
                    }
                    alt="Home"
                    className="dashboard-icon"
                  />
                  {homeTranslation}
                </span>
              </button>

              <button
                className={`dashboard-button ${location.pathname === "/chat"
                  ? "active"
                  : isDarkMode
                    ? "dark-mode"
                    : "light-mode"
                  }`}
                onClick={() => handleNavigation("/chat")}
              >
                <span className="icon-label">
                  <img
                    src={
                      location.pathname === "/chat"
                        ? carbonChatOrange
                        : isDarkMode
                          ? carbonChatDark
                          : chatIcon
                    }
                    alt="Chat"
                    className="dashboard-icon"
                  />
                  {chatTranslation}
                </span>
              </button>

              <button
                className={`dashboard-button ${location.pathname === "/npp-academy"
                  ? "active"
                  : isDarkMode
                    ? "dark-mode"
                    : "light-mode"
                  }`}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    "https://upllimited.sharepoint.com/sites/NPPEAcademy",
                    "_blank"
                  );
                }}
              >
                <span className="icon-label">
                  <img
                    src={
                      location.pathname === "/npp-academy"
                        ? carbonBookOrange
                        : isDarkMode
                          ? carbonBookDark
                          : carbonBook
                    }
                    alt="Academy"
                    className="dashboard-icon"
                  />
                  {academyTranslation}
                </span>
              </button>

              <div ref={feedbackContainerRef}>
                <button
                  className={`dashboard-button ${location.pathname === "/feedback"
                    ? "active"
                    : isDarkMode
                      ? "dark-mode"
                      : "light-mode"
                    }`}
                  onClick={toggleFeedbackPopup}
                >
                  <span className="icon-label">
                    <img
                      src={
                        location.pathname === "/feedback"
                          ? feedbackIconOrange
                          : isDarkMode
                            ? carbonFeedbackDark
                            : feedbackIcon
                      }
                      alt="Feedback"
                      className="dashboard-icon"
                    />
                    {feedbackTranslation}
                  </span>
                </button>
                {isFeedbackOpen && <FeedbackPopup onClose={toggleFeedbackPopup} />}
              </div>
            </div>
          </div>
          <div className={`logout-mobile ${isDarkMode ? "dark-mode" : "light-mode"}`}>
          <div className="dropdown-logout">
            <div className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`} onClick={handleFaqNavigation}>
              <span className="dropdown-icon">
                <img src={isDarkMode ? faqDark : faqLight} alt="settings-icon" />
              </span>
              {userGuideText}
            </div>
            <div
              className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`}
              onClick={() => handleOpenModalPolicy("About")}
            >
              <span className="dropdown-icon">
                <img src={isDarkMode ? aboutIconDark : aboutIcon} alt="" />
              </span>
              {"Model Selection Guide"}
            </div>
            <div
              className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`}
              onClick={() => handleOpenModalPolicy("AI Usage Policy")}
            >
              <span className="dropdown-icon">
                <img src={isDarkMode ? policyIconDark : policyIcon} alt="" />
              </span>
              {"AI Usage Policy"}
            </div>
             <div className={`dropdown-item-settings ${isDarkMode ? "dark-mode" : "light-mode"}`} onClick={handleOpenModal}>
              <span className="dropdown-icon">
                <img src={isDarkMode ? logoutDark : logoutIcon} alt="settings-icon" />
              </span>
              {logoutText}
            </div>
            </div>
          </div>
        </div>
      )}
      {isMobile && (
        <div className="mobile-navbar">
          <div className="mobile-left">
            <button className="hamburger-btn" onClick={toggleSidebar}>
              <img src={isDarkMode ? hamburgerDark : hamburger} alt="hamburger-icon" /></button>
          </div>
          <div className="mobile-right">
            <button onClick={toggleDarkMode} className="theme-container">
              <img src={isDarkMode ? darkMode : lightMode} alt="theme" />
            </button>
             <Dropdown
                label={language}
                items={languages}
                selectedItem={manualLanguageSelected ? selectedPlaceholderLanguage : placeholderLanguage}
                setSelectedItem={(lang) => {
                setSelectedLanguage(lang);
                setManualLanguageSelected(true);
                setManualCountrySelected(false);
                localStorage.setItem("manualLanguageSelected", "true");
                }}
                dropdownState={openDropdown === "language"}
                setDropdownState={() => toggleDropdown("language")}
                icon={isDarkMode ? languageLogoDark : languageLogo}
              />
              <Dropdown
                label={country}
                items={countries}
                selectedItem={manualCountrySelected ?selectedCountry : countries[0]}
                setSelectedItem={(country) => {
                setSelectedCountry(country);
                setManualCountrySelected(true);
                 encrypted.setEncryptedItem("country", country); 
                }}
                dropdownState={openDropdown === "country"}
                setDropdownState={() => toggleDropdown("country")}
                icon={isDarkMode ? globalIconDark : globalIcon}
              />
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;

const LogoutModal = ({ show, handleLogout, handleClose, translations }) => {
  if (!show) {
    return null;
  }

  const logoutQuery = translations["logout_query"] || "Are you sure you want to LogOut?";
  const logoutYes = translations["logout_yes"] || "Yes";
  const logoutNo = translations["logout_no"] || "No";
  const logoutText = translations["logout"] || "Log out?";

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="logout-icon">
          <img src={logoutIconPopup} alt="Logout Icon" />
          <span className="logout-header">{logoutText}?</span>
        </div>

        <div className="logout-text">
          {logoutQuery}
        </div>
        <div className="modal-buttons">
          <button onClick={handleLogout} className="yes-btn">{logoutYes}</button>
          <button onClick={handleClose} className="no-btn">{logoutNo}</button>
        </div>
      </div>
    </div>
  );
};